import valueFilters from '../valueFilters';
import util from '../util';
import globalRelay from 'Scripts/globalRelay';

const SCHEMA_VERSION = globalRelay.defaultSchemaVersion;

const model = {
	// Note: only present on guid key models
	relayId: {},
	key: {
		defaultValue: util.generateGuid // Note: only valid for GuidKeyModels. KeyNameModels should override this
	},
	// Note: only present on guid key models
	itemVersion: {
	},
	createdById: {
	},
	dateCreated: {
		setFilters: valueFilters.toUtcDate
	},
	lastModifiedById: {
	},
	dateLastModified: {
		setFilters: valueFilters.toUtcDate
	},
	dateModifiedOrCreated: {
		writable: false,
		nonSerialized: true
	},
	_get_dateModifiedOrCreated: function () {
		return this.dateLastModified || this.dateCreated;
	},
	modifiedOrCreatedById: {
		writable: false,
		nonSerialized: true
	},
	_get_modifiedOrCreatedById: function () {
		return this.lastModifiedById || this.createdById;
	},
	relayNumber: {
		writable: false,
		nonSerialized: true
	},
	_get_relayNumber: function () {
		return this.relayId && util.formatRelayNumber(this.getModelName(), this.relayId);
	},
	schemaVersion: {
		setFilters: valueFilters.toNumber,
		defaultValue: () => SCHEMA_VERSION
	},
	getPatch: function (target, keys, context) {
		const basePath = (context && context.path) || '';
		const contextPatchLength = context ? context.jsonPatch.length : 0;
		const result = this._getPatch(target, keys, context);


		/** //TODO:
		 * @apology Sorry in advance
		 * 
		 * @description logic that will migrate anything with SCHEMA_VERSION = 0 to SCHEMA_VERSION = 1
		 * 
		 * @olde_code : The olde code, which was used to "auto-migrate" the schema in 2019
		 * 	
		 * if (result.length > contextPatchLength && this.schemaVersion !== SCHEMA_VERSION) {
		 * 		const path = basePath + '/schemaVersion';
		 * 		result.push({ op: 'replace', path, value: SCHEMA_VERSION });
		 * 		this.schemaVersion = SCHEMA_VERSION;
		 * 	}
		 * 
		 * @see jobCostLineItemModel.vendorKey.rules for the reason this logic was created in the first place
		 * 
		 * @todo Address the issues that were created from doing the SCHEMA_VERSION bump from 1 to 2 without doing the accompanying migration. 
		 *
		 * @todo when migrating to fix this make sure everything will cascade properly (also cascading delete stuff)
		 */
		//console.log(this, this.name || this.description, this.schemaVersion)
		if (result.length > contextPatchLength && this.schemaVersion === 0) {
			const path = basePath + '/schemaVersion';

			result.push({ op: 'replace', path, value: 1 });
			this.schemaVersion = 1;
		}

		return result;
	}
};

export default model;